import { Routes } from '@angular/router';
import { DashboardPage } from './pages/dashboard-page/dashboard-page';
import { SitesPage } from './pages/sites-page/sites-page';
import { LandingPagesPage } from './pages/landing-pages-page/landing-pages-page';
import { LandingPageEditorPage } from './pages/landing-page-editor-page/landing-page-editor-page';
import { SiteDetailPage } from './pages/site-detail-page/site-detail-page';
import { LinksPage } from './pages/links-page/links-page';
import { LinkEditorPage } from './pages/link-editor-page/link-editor-page';
import { BlogpostsPage } from './pages/blogposts-page/blogposts-page';
import { BlogpostEditorPage } from './pages/blogpost-editor-page/blogpost-editor-page';
import { ApiKeysPage } from './pages/api-keys-page/api-keys-page';
import { ImagesPage } from './pages/images-page/images-page';
import { GalleriesPage } from './pages/galleries-page/galleries-page';

export const routes: Routes = [
    {
        path: '',
        component: DashboardPage,
    },
    {
        path: 'landing-pages/new',
        component: LandingPageEditorPage,
    },
    {
        path: 'landing-pages/:landingPageId',
        component: LandingPageEditorPage,
    },
    {
        path: 'landing-pages',
        component: LandingPagesPage,
    },
    {
        path: 'links/new',
        component: LinkEditorPage,
    },
    {
        path: 'links/:linkId',
        component: LinkEditorPage,
    },
    {
        path: 'links',
        component: LinksPage,
    },
    {
        path: 'blogposts/new',
        component: BlogpostEditorPage,
    },
    {
        path: 'blogposts/:blogpostId',
        component: BlogpostEditorPage,
    },
    {
        path: 'blogposts',
        component: BlogpostsPage,
    },
    {
        path: 'images',
        component: ImagesPage,
    },
    {
        path: 'galleries',
        component: GalleriesPage,
    },
    {
        path: 'sites',
        component: SitesPage,
    },
    {
        path: 'sites/:siteId',
        component: SiteDetailPage,
    },
    {
        path: 'api-keys',
        component: ApiKeysPage,
    },
];
